var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFurniture = function SvgFurniture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#furniture_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5DD927",
    d: "M14 2.5H6A2.5 2.5 0 0 0 3.5 5v1.25A3.26 3.26 0 0 0 2 6.01V5a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v1.01a3.3 3.3 0 0 0-1.5.24V5A2.5 2.5 0 0 0 14 2.5M17.75 7q.128-.001.25.013c1.125.125 2 1.078 2 2.237v4.25a1.5 1.5 0 0 1-1.5 1.5H17c-.653 0-1.21-.419-1.415-1H4.413c-.207.581-.763 1-1.416 1h-1.5a1.5 1.5 0 0 1-1.5-1.5L0 9.25A2.251 2.251 0 0 1 3.531 7.4c.522.362.882.938.954 1.6h11.028a2.25 2.25 0 0 1 .953-1.6c.362-.253.806-.4 1.281-.4zM17 9.25v4.25h1.5V9.25a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75m-1.5 3.25v-2h-11v2zM3 12.5V9.25a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v4.25H3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "furniture_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v16H0z"
  })))));
};
export default SvgFurniture;